// Primary color system - matches CSS variables in index.css
export const primaryColors = {
  primary: "#29a3b1",
  primaryRgb: "41, 163, 177",
  
  // Interactive state variations
  hover: "#3bb5c4",        // Lighter for hover states
  hoverRgb: "59, 181, 196",
  active: "#228792",       // Darker for active/pressed states
  activeRgb: "34, 135, 146",
  selected: "#2a6d76",     // Even darker for selected states
  selectedRgb: "42, 109, 118",
  
  // Primary with clean opacity levels (rounded to 5% increments)
  primary05: `rgba(41, 163, 177, 0.05)`,  // 5%
  primary10: `rgba(41, 163, 177, 0.1)`,   // 10%
  primary40: `rgba(41, 163, 177, 0.4)`,   // 40%
  primary60: `rgba(41, 163, 177, 0.6)`,   // 60%
  primary75: `rgba(41, 163, 177, 0.75)`,  // 75%
  primary80: `rgba(41, 163, 177, 0.8)`,   // 80%
  primary85: `rgba(41, 163, 177, 0.85)`,  // 85%
  primary100: `rgba(41, 163, 177, 1)`,    // 100%
  
  // State variations with opacity
  hoverWithOpacity: (opacity) => `rgba(59, 181, 196, ${opacity})`,
  activeWithOpacity: (opacity) => `rgba(34, 135, 146, ${opacity})`,
  selectedWithOpacity: (opacity) => `rgba(42, 109, 118, ${opacity})`,
  
  // Function to create custom opacity (base color)
  withOpacity: (opacity) => `rgba(41, 163, 177, ${opacity})`
};

export const colors = {
  building: "#ea5e5e",
  vegetation: "#4dd599",
  pavement: "#5f6769",
  water: "#42dee1",
  tree: "#007944",
  street: "#FFA500",
  emission: "#e6b300",
  windTurbine: "#1a55c2",
  rasterFilling: "#EC058E",
  singleTree: "#007944",

  selectedBuilding: "#c85e5e",
  seletedVegetation: "#2dbe7f",
  selectedPavement: "#8c9597",
  selectedWater: "#19a1a3",
  selectedTree: "#00b365",
  selectedStreet: "#FFA500",
  default: "black",
};

export const switchColor = {
  building: "#D66565",
  vegetation: "#2dbe7f",
  pavement: "#8c9597",
  water: "#19a1a3",
  treePatches: "#00b365",
  singleTree: "#00b365",
  street: "#e6b300",
  emission: "#e6b300",
  mapPoi: "#c21aa8",
  windTurbine: "#1a55c2",
  default: "#ffffff",
};
